import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer, MainContainer } from '../../ui';
import { ArbiWinHeader, ArbiWinFooter } from '../../ui';
import LoginForm from './LoginForm.jsx';
import { DEFAULT_REDIRECTS } from '../../../config/routes';

const LoginPage = function LoginPage() {
  const navigate = useNavigate();
  
  return (
    <PageContainer>
      <ArbiWinHeader 
        isAuthenticated={false}
        onLogin={() => navigate('/login')}
        onRegister={() => navigate('/register')}
        onHomeClick={() => navigate('/')}
      />
      <MainContainer>
        <div style={{ maxWidth: 480, margin: '0 auto', padding: 'var(--spacing-8) var(--spacing-4)' }}>
          <LoginForm onSuccess={function() { window.location.href = DEFAULT_REDIRECTS.AFTER_LOGIN; }} />
        </div>
      </MainContainer>
      <ArbiWinFooter />
    </PageContainer>
  );
};

LoginPage.displayName = 'LoginPage';

export default LoginPage;


